import { EItemType, TGameItem } from "./inventoryTypes";

/**
 * Retrieves the details of a game item by its unique identifier.
 *
 * @param Id - The unique identifier of the game item to retrieve.
 * @returns The game item details as a `TGameItem` object if found, or `undefined` if no item matches the given ID.
 */
export function getItemDetails(Id: number): TGameItem | undefined {
    return GameItems.find(item => item.Id === Id);
}

export const GameItems: TGameItem[] = [
    {
        Id: 1,
        Name: 'Colt Peacemaker',
        Description: ".45, durable, reliable, accurate, 'The Gun That Won the West'",
        Type: EItemType.Pistol,
        Damage: 4,
        Caliber: '.45'
    },
    {
        Id: 2,
        Name: 'Smith & Wesson Model 3',
        Description: ".45 popular with cavalry, Jesse James and General Custer are fans.",
        Type: EItemType.Pistol,
        Damage: 3,
        Caliber: '.45'
    },
    {
        Id: 3,
        Name: 'Remington Model 1875',
        Description: ".44, Durable, and very popular.",
        Type: EItemType.Pistol,
        Damage: 2,
        Caliber: '.44-40'
    },
    {
        Id: 4,
        Name: 'Colt 1860',
        Description: ".44 Reliable but somewhat out of date now.",
        Type: EItemType.Pistol,
        Damage: 1,
        Caliber: '.44'
    },
    {
        Id: 5,
        Name: 'Winchester Model 1873',
        Description: "Lever-action, fast firing, and popular as heck.",
        Type: EItemType.Rifle,
        Damage: 4,
        Caliber: '.44-40'
    },
    {
        Id: 6,
        Name: 'Sharps Rifle',
        Description: "Single-shot but extremely accurate. Used by buffalo hunters and snipers.",
        Type: EItemType.Rifle,
        Damage: 3,
        Caliber: '.70'
    },
    {
        Id: 7,
        Name: 'Springfield Model 1873 Trapdoor',
        Description: "Not as quick as lever-action, but powerful and common.",
        Type: EItemType.Rifle,
        Damage: 2,
        Caliber: '.70'
    },
    {
        Id: 8,
        Name: 'Winchester Model 1885 High Wall',
        Description: "Designed by John Browning.",
        Type: EItemType.Rifle,
        Damage: 1,
        Caliber: '.70'
    },
]


